<template>
  <div class="cv-header py-2">
    <div class="cv-header-nav">
      <v-btn
        v-if="showTodayButton"
        depressed
        class="mr-3"
        color="grey lighten-4"
        small
        @click="onInput(headerProps.currentPeriod)"
      >
        {{ $t('message.today') }}
      </v-btn>
      <!--<button :disabled="!headerProps.previousYear" class="previousYear" @click="onInput(headerProps.previousYear)">&lt;&lt;</button>-->
      <v-btn text icon :disabled="!headerProps.previousPeriod" small @click="onInput(headerProps.previousPeriod)">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <v-btn text icon :disabled="!headerProps.nextPeriod" small @click="onInput(headerProps.nextPeriod)">
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
      <!--<button :disabled="!headerProps.nextYear" class="nextYear" @click="onInput(headerProps.nextYear)">&gt;&gt;</button>-->
    </div>
    <div
      class="text-capitalize ml-3 subtitle-2"
      :class="{
        subheading: $vuetify.breakpoint.xsOnly,
        headline: $vuetify.breakpoint.smAndUp
      }"
    >
      <slot name="label">
        {{ headerProps.periodLabel }}
      </slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AppCalendarViewHeader',
  props: {
    headerProps: {
      type: Object,
      required: true
    }
  },
  computed: {
    showTodayButton() {
      return !this.headerProps.periodLabel.includes(' – ')
    }
  },
  methods: {
    onInput(d) {
      this.$emit('input', d)
    }
  }
}
</script>
